<template>
<div>
  <span class="span" @click="changeLang()">EN/中文</span>
</div>
</template>

<script>
export default {
  data() {
    return {
      lang: "",
    };
  },
  methods: {
    //   切换语言
    changeLang() {
      if (this.lang == "zh") {
        this.lang = "en";
        this.$i18n.locale = "en";
        localStorage.setItem("lang", "en");
        this.$store.commit('setLang','en');
      } else {
        this.lang = "zh";
        this.$i18n.locale = "zh";
        localStorage.setItem("lang", "zh");
        this.$store.commit('setLang','zh');
      }
    },
  },
  created() {
    this.lang = localStorage.getItem("lang") || "zh";
  },
}
</script>

<style scoped lang="scss">
  .span{
    color:#FF625A;
    border: 1px solid #FF625A;
    margin-left: 5px;
    padding: 0 5px;
    cursor: pointer;
  }
</style>
